import React from "react";
import { money } from "./territory-redesign-kit";

/*
 * Shared pieces of the yearly-goal pages (Sales targets and Store goals, redesign 2026-10-09):
 * one yearly goal per row, spread across the months by last year's monthly pattern.
 * Styles: stg-* in sass/v2/_sales-targets.scss.
 */
export const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

// "$1.13M" for goals (two decimals reads better for plans), the kit's rounding otherwise.
export function goalMoney(v) {
  const n = Number(v) || 0;
  if (Math.abs(n) >= 999500 && Math.abs(n) < 1e9) return `$${(n / 1e6).toFixed(2)}M`;
  return money(n);
}

// "1.13M", "$564K", "250,000" → number; null when it doesn't read as an amount.
export function parseAmount(text) {
  const t = String(text || "").trim().replace(/[$,\s]/g, "").toLowerCase();
  if (!t) return null;
  const m = t.match(/^(\d*\.?\d+)([km]?)$/);
  if (!m) return null;
  const mult = m[2] === "m" ? 1e6 : m[2] === "k" ? 1e3 : 1;
  return Math.round(Number(m[1]) * mult);
}

// Split a yearly amount across months by weights (whole dollars; the last month takes the rounding).
export function spread(total, weights) {
  const n = weights.length;
  const sum = weights.reduce((a, w) => a + (w > 0 ? w : 0), 0);
  const share = weights.map(w => sum > 0 ? (w > 0 ? w : 0) / sum : 1 / n);
  const out = share.map(s => Math.round(total * s));
  const diff = total - out.reduce((a, v) => a + v, 0);
  // Put the remainder on the largest month so a zero month stays zero.
  let big = 0;
  share.forEach((s, i) => {
    if (s > share[big]) big = i;
  });
  out[big] += diff;
  return out;
}
export function Bars({
  values,
  muted
}) {
  const vals = (values || []).map(v => Math.max(0, Number(v) || 0));
  const mx = Math.max(...vals, 0);
  if (!mx) return /*#__PURE__*/React.createElement("span", {
    className: "stg-bars empty",
    "aria-hidden": "true"
  });
  return /*#__PURE__*/React.createElement("span", {
    className: `stg-bars${muted ? " muted" : ""}`,
    "aria-hidden": "true"
  }, vals.map((v, i) => /*#__PURE__*/React.createElement("i", {
    key: i,
    style: {
      height: `${Math.max(2, Math.round(v / mx * 100))}%`
    },
    title: `${MONTHS[i]}: ${money(v)}`
  })));
}